import { Grid } from '@material-ui/core';
import React from 'react';
import { ListDecoratedMedisanteDevice, DevicesSortBy } from '../../types';
import { SortOption, SortState } from '../../../../utils/sort';
import { useDevicesTableColumns, useInfinitePaginationWithRef } from './hooks';
import { useStyles } from './styles';
import InfiniteTable from '../../../../components/InfiniteTable/InfiniteTable';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { IDialogState } from '../../../../components/ActionsMenu/types';
import { isBluetoothDevice } from '../../../Device/types';

interface Props {
  selectedDeviceIds: string[];
  devices: ListDecoratedMedisanteDevice[];
  sortState: SortState<ListDecoratedMedisanteDevice>;
  updateSortState: React.Dispatch<SortOption<DevicesSortBy>>;
  measurementCount: number;
  selectAll: { all: boolean; some: boolean };
  onSelectionChanged: (id: string) => void;
  onSelectAllChanged: () => void;
  readonly actionMenuDialogState: IDialogState;
  actionMenuUpdateDialogState: (action: string) => void;
  totalView: boolean;
}

function DevicesTable(props: Props) {
  const {
    devices,
    selectedDeviceIds,
    sortState,
    updateSortState,
    measurementCount,
    selectAll,
    onSelectionChanged,
    onSelectAllChanged,
    actionMenuDialogState,
    actionMenuUpdateDialogState,
    totalView,
  } = props;

  const containsBluetooth = devices.some((d) => isBluetoothDevice(d.model));
  const tableColumns = useDevicesTableColumns(
    selectedDeviceIds,
    sortState,
    updateSortState,
    selectAll,
    onSelectionChanged,
    onSelectAllChanged,
    actionMenuDialogState,
    actionMenuUpdateDialogState,
    totalView,
    containsBluetooth
  );
  const [data, nextPage, hasMore, page] = useInfinitePaginationWithRef<
    ListDecoratedMedisanteDevice,
    HTMLDivElement
  >(devices);

  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const setSnack = (snack: string) => {
    enqueueSnackbar(snack, {
      variant: 'info',
      disableWindowBlurListener: true,
    });
  };

  return (
    <>
      <InfiniteTable
        page={page}
        containerClass={classes.container}
        loadMore={nextPage}
        hasMore={hasMore}
        data={data}
        tableColumns={tableColumns}
        sortState={sortState}
        getKeyValue={(d) => d.id}
        onRowClick={(entity) => {
          history.push(`/devices/${encodeURIComponent(entity.id)}`);
        }}
        onDoubleClick={(txt) => {
          if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(txt);
            setSnack(`${txt} copied to clipboard`);
          }
        }}
      />
      <Grid
        container
        className={classes.summary}
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item className={classes.summaryItem}>
          Total device count: {devices.length.toLocaleString()}
        </Grid>
        {/*<Grid item className={classes.summaryItem}>*/}
        {/*  Total archived device count: {archivedDeviceCount}*/}
        {/*</Grid>*/}
        <Grid item className={classes.summaryItem}>
          Total measurement count: {measurementCount.toLocaleString()}
        </Grid>
      </Grid>
    </>
  );
}

export default DevicesTable;
